import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
var checkSerializableWithoutCircularReference = function(o, seen, location) {
    if (o === undefined || o === null || typeof o === "boolean" || typeof o === "number" || typeof o === "string") {
        return {
            serializable: true
        };
    }
    if (Object.prototype.toString.call(o) !== "[object Object]" && !Array.isArray(o)) {
        return {
            serializable: false,
            location: location,
            reason: typeof o === "function" ? "Function" : String(o)
        };
    }
    if (seen.has(o)) {
        return {
            serializable: false,
            reason: "Circular reference",
            location: location
        };
    }
    seen.add(o);
    if (Array.isArray(o)) {
        for(var i = 0; i < o.length; i++){
            var childResult = checkSerializableWithoutCircularReference(o[i], new Set(seen), _to_consumable_array(location).concat([
                i
            ]));
            if (!childResult.serializable) {
                return childResult;
            }
        }
    } else {
        for(var key in o){
            var childResult1 = checkSerializableWithoutCircularReference(o[key], new Set(seen), _to_consumable_array(location).concat([
                key
            ]));
            if (!childResult1.serializable) {
                return childResult1;
            }
        }
    }
    return {
        serializable: true
    };
};
export default function checkSerializable(o) {
    return checkSerializableWithoutCircularReference(o, new Set(), []);
}
